// {{component}}.js
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    item:{
      type: Object,
      value: {}
    }
  },
  lifetimes:{
    attached(){
      console.log("resultItem",this.data.item);
    }
  },
  /**
   * 组件的初始数据
   */
  data: {

  },

  /**
   * 组件的方法列表
   */
  methods: {
    seeLuckList(){
      this.triggerEvent("seeLuckList",{
        backIcon: false
      })
    }
  }
})
